/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateNextBestAction} from '../api'

export const useMutationUpdateNextBestAction = createReactQueryMutationHook('updateNextBestAction', updateNextBestAction)
